import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { PrivateAccess } from '@wf/keycloak-axios-provider';
import { GroupButton } from '@wf/components';

import { declarantAndTraderRoles } from '../../../../constants';
import { Status } from '../../types/enums';

import { feesSelector, licenseStatusSelector } from '../../store/selectors';
import { invoiceUrlSelector } from '../../../../store/configs/selectors';

function PaylicanPayment() {
  const { t } = useTranslation();
  const licenseStatus = useSelector(licenseStatusSelector);
  const invoiceUrl = useSelector(invoiceUrlSelector);
  const { billNumber } = useSelector(feesSelector);

  const handleInitiatePayment = () => {
    window.open(`${invoiceUrl!}${billNumber!}`, '_blank');
  };

  if (licenseStatus === Status.PENDING_PAYMENT) {
    return (
      <PrivateAccess roles={declarantAndTraderRoles}>
        {billNumber && invoiceUrl ? (
          <GroupButton.Button type="button" onClick={handleInitiatePayment}>
            {t('Start payment')}
          </GroupButton.Button>
        ) : null}
      </PrivateAccess>
    );
  }

  return null;
}

export default PaylicanPayment;
